<template>
    <div class="pt-8">
        <v-form>
            <v-expansion-panels v-if="routes" class="px-2 mb-10">
                <v-expansion-panel v-for="(item, key) in routes" :key="key">
                    <v-expansion-panel-header>{{ key }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="d-flex justify-content-end">
                            <v-switch
                                :label="t('roles::routes.select_group')"
                                :value="isGroupSelected(key)"
                                :disabled="role.readonly"
                                @change="selectGroup($event, key)"
                            ></v-switch>
                        </div>
                        <v-row no-gutters>
                            <v-col v-for="route in item" :key="route.id" cols="12" lg="3" md="6" sm="12">
                                <v-checkbox
                                    v-model="permissions"
                                    :label="route.name"
                                    :value="route.id"
                                    :disabled="role.readonly"
                                    color="primary"
                                    dense
                                    hide-details
                                    size="100%"
                                    @change="changePermission($event, route.id)"
                                >
                                </v-checkbox>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            validationRules: {
                permissions: [(v) => !!v || t('users::validation.field.required')],
            },
        };
    },
    computed: {
        role() {
            return this.$store.state.dms_roles.dms_role;
        },
        permissions: {
            get() {
                return this.$store.state.dms_roles.dms_role.acl_routes;
            },
            set() {
                //this.$store.dispatch('dms_roles/updateProperty', {property: 'acl_routes', value});
            },
        },
        routes() {
            return this.$store.state.dms_roles.permissionsOptions;
        },
        readOnlyRules() {
            return !this.can('api.v1.roles.update') || this.role.readonly;
        },
    },
    methods: {
        changePermission(all, routeId) {
            this.$store.dispatch('dms_roles/changePermissions', { all: this.permissions, routeId });
        },
        isGroupSelected(group) {
            let permissions = this.permissions;
            return this.routes[group].every(function (val) {
                return permissions.includes(val.id);
            });
        },
        selectGroup(value, group) {
            let permissions = this.permissions;

            if (value === true) {
                this.routes[group].forEach(function (val) {
                    let index = permissions.indexOf(val.id);
                    if (index < 0) {
                        permissions.push(val.id);
                    }
                });
            } else {
                this.routes[group].forEach(function (val) {
                    let index = permissions.indexOf(val.id);
                    if (index > -1) {
                        permissions.splice(index, 1);
                    }
                });
            }

            this.permissions = permissions;
        },
    },
};
</script>
